import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { IMG_PAYMENT_CARD, IconEdit, IconDelete, IconCopy } from "@assets";
import { Button, Col, message, Row, Space, Switch } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { Route, Routes, useNavigate } from "react-router-dom";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import AddPaymentMethod from "./AddPaymentMethod/AddPaymentMethod";
import api from "../../../../api/api";
import EditPaymentMethod from "./EditPaymentMethod/EditPaymentMethod";
import DeleteModal from "./DeleteModal/DeleteModal";
import UpdateStatusModal from "./UpdateStatusModal/UpdateStatusModal";
import SwapPaymentAutoManual from "./SwapPaymentAutoManual";
import { createGlobalStyle } from "styled-components";
import { Spin } from "antd";
import { IconCOD } from "../../../../assets/PaymentIcon";
import { useTranslation } from "react-i18next";

const RootContainer = styled.div`
position:relative;
`;

const Title = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: #1e1e1e;
`;

const NewBox = styled.div`
  padding: 24px;
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: flex-start;
  background-color: ${(props) => props.theme.backgroundColor};
  border-radius: 8px;
  @media (max-width: 480px) {
 flex-direction:column;
}
`;

const LeftBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  justify-content: center;
  border-right: 1px solid #b9b9b9;

  @media (max-width: 480px) {
  border-right:none;
}
  .ant-btn {
    width: 172px;
    height: 48px;
  }
`;

const ImageWrapper = styled.div`
  padding: 0 5%;
`;

const Image = styled.img.attrs({
  alt: "img",
  src: IMG_PAYMENT_CARD,
})`
  height: 146px;
  width: auto;
`;

const BoldText = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #1e1e1e;
`;

export const LightText = styled.div`
  font-size: 15px;
  font-weight: 400;
  color: #868686;
`;

const Text = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #1e1e1e;
`;

const NameText = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #272727;
  text-align: left;
  word-break: break-word;
  white-space: normal;   
`;

const PaymentNameText = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #272727;
  text-align: center;
  word-break: break-word;
  white-space: normal;   
`;

const NumText = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #006afb;
  word-break: break-word;
  white-space: normal;
`;

const LinkText = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #006afb;
  text-decoration: underline;
  cursor: pointer;
`;

const ListCard = styled.div`
  width: 100%;
  padding: 20px 24px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: flex-start;
  justify-content: flex-start;
  background-color: ${(props) => props.theme.backgroundColor};

  .ant-row {
    width: 100%;
  }
`;

const ItemCard = styled.div`
  width: 280px;          /* fixed width */
  min-height: 340px;         /* fixed height */
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  justify-content: flex-start;
  background-color: #fff;
  border-radius: 8px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: ${(props) => (props.isDragging ? "grabbing" : "grab")};

  ${(props) =>
    props.isDragging &&
    `
    transform: scale(1.02);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
    z-index: 1000;
  `}

  > div:first-child {
    display: flex;
    gap: 24px;
  }

  svg {
    cursor: pointer;
  }
    
  .ant-switch {
    min-width: auto;
    height: 24px;
  }

  .ant-switch-handle {
    top: 3px;
  }

  .ant-switch-inner {
    width: 40px;
    height: 24px;
    background: #f00;
  }

  .ant-switch-checked .ant-switch-inner {
    background: #009800 !important;
  }

  img {
    opacity: ${(props) => (props.disabled ? 0.5 : 1)};
    width: 72px;
    height: 72px;
    object-fit: cover;
    border-radius: 8px;
  }
`;

const InforCard = styled.div`
  width: 100%;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: flex-start;
  justify-content: flex-start;
  border-radius: 8px;
  background-color: #f5f5f5;
`;

const DragHandle = styled.div`
  position: absolute;
  top: 4px;
  right: 4px;
  padding: 4px;
  cursor: grab;
  color: #999;
  font-size: 18px;

  &:hover {
    color: #666;
  }

  &:active {
    cursor: grabbing;
  }
`;

const PaymentCheckBox = styled.div`
 width: fit;
 height: 32px;
 border-radius: 999px;
 padding: 8px;
 background-color: #ECFAE6;
 display:flex;
 justify-content:center;
 align-items:center;
 gap:5px;
`
const GreenDot = styled.span`
    width:10px;
    height:10px;
    border-radius: 100%;
    background-color: #319300;
`
const PaymentStatusContainer = styled.div`
  width: 100%;
  height: 68px;
  background: #F0F6FE;
  border: 1px solid #D9E4FF;
  border-radius: 12px;
  padding: 0 16px;
  margin: 30px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const PaymentLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const PaymentIconBox = styled.div`
  width: 44px;
  height: 32px;
  border-radius: 6px;
  background: #ffffff;
  border: 1px solid #e5e5e5;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const PaymentTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size:16px;
  font-weight: 600;
`;

const ActiveBadge = styled.span`
  background: #319300;
  color: #FFFFFF;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 500;
`;

const InactiveBadge = styled.span`
  background: #d92d20;
  color: #FFFFFF;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
`;

const StyledSwitch = styled(Switch)`
  &.ant-switch {
    background-color: #bfbfbf;
  }

  &.ant-switch-checked {
    background-color: #34c759;
  }

  &.ant-switch-disabled {
    background-color: #e5e5e5 !important;
    cursor: not-allowed;
  }
`;

const RemovePaddingStyle = createGlobalStyle`
  .kEByxh {
    padding: 0 !important;
  }
`;

const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 9999;
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  display: flex;
  justify-content: center;
  align-items: center;
  height:80vh;
`;

// Sortable Item Component
const SortableItem = ({
  item,
  deleteSuccessCallback,
  changeStatusSuccessCallback,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: item.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style}>
      <Item
        item={item}
        deleteSuccessCallback={deleteSuccessCallback}
        changeStatusSuccessCallback={changeStatusSuccessCallback}
        isDragging={isDragging}
        dragHandleProps={{
          ...attributes,
          ...listeners,
        }}
      />
    </div>
  );
};

const Item = ({
  item,
  deleteSuccessCallback,
  changeStatusSuccessCallback,
  isDragging,
  dragHandleProps,
}) => {
  const navigate = useNavigate();
  const [openDelete, setOpenDelete] = useState(false);
  const [open, setOpen] = useState(false);

  const {t} = useTranslation();

  const handleChangeStatus = () => {
    setOpen(true);
  };

  const handleEditClicked = () => {
    navigate(`edit-payment/${item.id}`);
  };

  const handleDeleteClicked = () => {
    setOpenDelete(true);
  };

  const handleCopyNumber = () => {
    navigator.clipboard
      .writeText(item.payment_acc_no)
      .then(() => message.success(t('copy_success')));
  };

  const handleDownloadQR = () => {
    const imageUrl = item.payment_qr;
    const fileName = `${item.payment_name.replace(
      /[^a-zA-Z0-9]/g,
      "_"
    )}_QR.png`;

    const link = document.createElement("a");
    link.href = imageUrl;
    link.download = fileName;
    link.target = "_blank";

    // Detect mobile
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      window.open(imageUrl, "_blank");
      message.info(t('image_open_in_new_tag'));
    } else {
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  return (
    <>
      <ItemCard
        disabled={!item.is_active ? 1 : 0}
        isDragging={isDragging}
        style={{ position: "relative" }}
      >
        {/* Drag Handle */}
        <DragHandle {...dragHandleProps}>⋮⋮</DragHandle>

        <div style={{ display: "flex", alignItems: "start", gap: 8,width:"100%",marginTop:"10px" }}>
          <div
            style={{
              width: "50%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: 10,
            }}
          >
            <img alt="img" src={item.payment_logo} />
            <PaymentNameText>{item.payment_name}</PaymentNameText>
          </div>
          <div
            style={{
              width: "50%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: 4,
            }}
          >
            <img alt="img" src={item.payment_qr} />
            <LinkText
              style={{ textOverflow: "ellipsis", whiteSpace: "nowrap" }}
              onClick={handleDownloadQR}
            >
              {t('download_qr')}
            </LinkText>
          </div>
        </div>
        <InforCard>
          <NameText>{item.payment_acc_name}</NameText>
          <Space>
            <NumText>{item.payment_acc_no}</NumText>
            <IconCopy onClick={handleCopyNumber} />
          </Space>
        </InforCard>
        <Space>
          <Switch value={item.is_active} onChange={handleChangeStatus} />
          <IconEdit onClick={handleEditClicked} />
          <IconDelete onClick={handleDeleteClicked} />
        </Space>
      </ItemCard>
      <DeleteModal
        id={item.id}
        open={openDelete}
        handleClose={() => setOpenDelete(false)}
        successCallback={deleteSuccessCallback}
      />
      <UpdateStatusModal
        id={item.id}
        open={open}
        handleClose={() => setOpen(false)}
        successCallback={changeStatusSuccessCallback}
      />
    </>
  );
};

const PaymentMethods = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [checkPayType,setCheckPayType] = useState("");
  const [successRecall, setSuccessRecall] = useState(false);

  //cod
const [codLoading, setCodLoading] = useState(false);
const [codStatus, setCodStatus] = useState(null); // true | false
const [codId, setCodId] = useState(null);

const {t} = useTranslation();


  // DnD Kit sensors
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  useEffect(() => {
    getPayments();

    // eslint-disable-next-line
  }, []);

  const getPayments = () => {
    api
      .getPayments()
      .then(({ data }) => {
        setLoading(false);
        setData(data);
      })
      .catch((error) => {
        message.error(error);
      });
  };

  const goToAddNew = () => {
    navigate("add-payment");
  };

  const deleteSuccessCallback = (id) => {
    setData((prev) => prev.filter((x) => x.id !== id));
  };

  const changeStatusSuccessCallback = (id) => {
    setData((prev) =>
      prev.map((x) => {
        if (x.id === id) {
          return {
            ...x,
            is_active: !x.is_active,
          };
        }
        return x;
      })
    );
  };

  // Handle drag end
  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (!over || active.id === over.id) return;

    const draggedId = active.id; // ID being dragged
    const targetId = over.id; // ID it was dropped on

    setData((items) => {
      const oldIndex = items.findIndex((item) => item.id === draggedId);
      const newIndex = items.findIndex((item) => item.id === targetId);
      const newOrder = arrayMove(items, oldIndex, newIndex);

      // Call API with draggedId as URL param, targetId as body payload
      api
        .updatePaymentSort(draggedId, targetId)
        .then(() => {
          message.success(t('oder_update_success'));
          getPayments();
        })
        .catch((err) => {
          message.error(t('fails_to_update'));
          console.error(t('swap_error'), err);
          // Optional: rollback UI
          return items; // revert visual order
        });

      return newOrder;
    });
  };

   const checkPaymentType = () => {
    setLoading(true);
    api
      .checkPaymentType()
      .then((res) => {
       const responseData = res?.data
        setCheckPayType(responseData?.auto_payment_status);
      })
      .catch((err) => message.error(err))
      .finally(() => setLoading(false));
  };
  
    useEffect(() => {
      checkPaymentType();
    }, [successRecall]);

 
    //cod
const getCodStatus = () => {
  setCodLoading(true);
  api
    .getCodStatus()
    .then((res) => {
      const data = res?.data;
      setCodStatus(data?.is_active);
      setCodId(data?.id);
    })
    .catch((err) => message.error(err))
    .finally(() => setCodLoading(false));
};

const handleCodToggle = (checked) => {
  setCodLoading(true);

  api
    .updateCodeStatusChange()
    .then(() => {
      setCodStatus(checked);
      message.success(
        `${t('cod')} ${checked ? t('enabled') : t('disabled')}`
      );
    })
    .catch((err) => {
      message.error(err);
    })
    .finally(() => setCodLoading(false));
};

useEffect(() => {
  checkPaymentType();
  getCodStatus();
}, [successRecall]);


  const NewCard = () => (
    <NewBox>
      <LeftBox>
        <BoldText>{t('manual_payment_method')}</BoldText>
        <Text>
         {t('you_can_set_payment_method')}
        </Text>
        <Button type="primary" icon={<PlusOutlined />} onClick={goToAddNew}>
          {t('add_payment')}
        </Button>
      </LeftBox>
      <ImageWrapper>
        <Image />
      </ImageWrapper>
    </NewBox>
  );

  return (
    <RootContainer>
        {loading && (
    <LoadingOverlay>
      <Spin size="large" />
    </LoadingOverlay>
  )}
         <div style={{display:"flex",alignItems:"center",gap:"10px",marginTop:"20px",marginBottom:"20px"}}>
      <Title>{t('payment_type_manual')}</Title>
      {checkPayType === "MANUAL_ENABLED" && 
     <PaymentCheckBox>
        <GreenDot/>
        <h3 style={{color:"#191114",fontSize:"16px",lineHeight:"26px",fontWeight:400}}>{t('using_now')}</h3>
     </PaymentCheckBox>
      }
      </div>
     
      <NewCard />

       <PaymentStatusContainer>
            <PaymentLeft>
              <PaymentIconBox>
                <IconCOD />
              </PaymentIconBox>

              <PaymentTitle>
                <h3
                  style={{
                    fontSize: 16,
                    fontWeight: 500,
                    margin: 0,
                    color: "#191114",
                  }}
                >
                  {t('cod')}
                </h3>

                {codStatus ? (
                  <ActiveBadge>{t('active')}</ActiveBadge>
                ) : (
                  <InactiveBadge>{t('inactive')}</InactiveBadge>
                )}
              </PaymentTitle>
            </PaymentLeft>

            <StyledSwitch
              checked={codStatus}
              loading={codLoading}
              disabled={codLoading || codStatus === null}
              onChange={handleCodToggle}
            />
          </PaymentStatusContainer>
      {(checkPayType !== "AUTO_PAYMENT_ENABLED" && !loading && data.length > 0) && (
        <ListCard>
          <BoldText>
            {t('save_payment_method')}{" "}
            <LightText>({t('you_can_drag_payment')})</LightText>
          </BoldText>
          <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
          >
            <SortableContext
              items={data.map((item) => item.id)}
              strategy={verticalListSortingStrategy}
            >
              <Row gutter={[24, 24]}>
                {data.map((item) => (
                  <Col key={item.id}>
                    <SortableItem
                      item={item}
                      deleteSuccessCallback={deleteSuccessCallback}
                      changeStatusSuccessCallback={changeStatusSuccessCallback}
                    />
                  </Col>
                ))}
              </Row>
            </SortableContext>
          </DndContext>
        </ListCard>
      )}
      {checkPayType === "AUTO_PAYMENT_ENABLED" && 
    <>
    <RemovePaddingStyle/> 
    <SwapPaymentAutoManual setSuccessRecall={setSuccessRecall} successRecall={successRecall} />
    </> 
    }
    </RootContainer>
  );
};

const Entry = () => {
  return (
    <Routes>
      <Route path="" element={<PaymentMethods />} />
      <Route path="/add-payment" element={<AddPaymentMethod />} />
      <Route path="/edit-payment/:id" element={<EditPaymentMethod />} />
    </Routes>
  );
};

export default Entry;
